<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Input the Transaction Code</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="{ id: cashout.id }"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-input name="key_code" label="Code" />
              </v-col>

              <v-col cols="12">
                <custom-button block color="primary">
                  Submit
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    cashout: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      users_data: [],
      cashout_methods_data: [],
      cached_bank_accounts: [],
      bank_accounts: [],
      key: 1,
    };
  },
  computed: {
    url() {
      return "api/v1/verifyPayout";
    },
    users() {
      return this.getUserOptions(this.users_data);
    },
    cashout_methods() {
      return this.getSelectOptions(this.cashout_methods_data);
    },
  },
  async created() {
    await this.fetchData();
  },
  watch: {
    // isActive() {
    //   this.key++;
    // },
  },
  methods: {
    getSelectOptions(data) {
      return data.map(({ id, name }) => ({ value: id, text: name }));
    },
    async updateBankAccounts(user_id) {
      await this.$http.get(`/api/v1/userBankAccounts/all/${user_id}`).then((response) => {
        this.bank_accounts = response.data;
      });
    },
    getUserOptions(data) {
      return data.map(({ id, full_name }) => ({ value: id, text: full_name }));
    },
    async fetchData() {
      await this.$http.get("/api/v1/users").then((response) => {
        this.users_data = response;
      });
      await this.$http.get("/api/v1/transactions/transferCashoutMethods/all").then((response) => {
        this.cashout_methods_data = response;
      });
      await this.$http.get("/api/v1/userBankAccounts/all").then((response) => {
        this.cached_bank_accounts = response.data;
      });
    },
  },
};
</script>
